import logo from '../../../img/Esplanebranco.png';
import logoBranco from '../../../img/logo-branco.png';
import { BrowserView, MobileView } from 'react-device-detect';
import { Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import '../../styles/formHeader.css';
import moment from 'moment';
import { SkeletonHeader } from '../Skeletons';


function Header({ dadosNF, isLoadingBody }) {
    return (
        <>
            <BrowserView>
                <div className='HeaderLogo'>
                    <div className='container-titles'>
                        <img src={logo} width={120} height={'auto'} alt='#' />

                        {!isLoadingBody ? (
                            <>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <p style={{ all: 'unset', color: 'white', fontSize: '20px' }}>{dadosNF.fec_infos?.[0]?.nomeparc}</p>
                                    <p style={{ all: 'unset', color: 'white', fontSize: '20px' }}>{dadosNF.fec_infos?.[0]?.razaosocial ? dadosNF.fec_infos?.[0]?.razaosocial + '(' + dadosNF.fec_infos?.[0]?.codparc + ')' : ''}</p>
                                    <p style={{ all: 'unset', color: 'white', fontSize: '16px' }}>CPF/CNPJ:{dadosNF.fec_infos?.[0]?.cpf ? dadosNF.fec_infos?.[0]?.cpf : ''}</p>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <p style={{ all: 'unset', color: 'white', fontSize: '14px' }} ><b>Vendedor: </b>{dadosNF.fec_infos?.[0]?.vendedor ? dadosNF.fec_infos?.[0]?.vendedor : '-'}</p>
                                    <p style={{ all: 'unset', color: 'white', fontSize: '14px', marginBottom: '5px' }}><Icon size='medium' color="green" name="whatsapp" />{dadosNF.fec_infos?.[0]?.telefone ? dadosNF.fec_infos?.[0]?.telefone : '-'}</p>
                                    <p style={{ all: 'unset', color: 'white', fontSize: '14px' }}>Pedido: {dadosNF.fec_infos?.[0]?.pedido ? dadosNF.fec_infos?.[0]?.pedido : ''}</p>
                                    <p style={{ all: 'unset', color: 'white', fontSize: '14px' }}>Data: {dadosNF.fec_infos?.[0]?.data_pedido ? moment(dadosNF.fec_infos?.[0]?.data_pedido).format('DD/MM/YYYY') : ''}</p>
                                </div>
                            </>
                        ) : (
                            <SkeletonHeader />
                        )}

                    </div>

                </div>
            </BrowserView>

            <MobileView>
                <div className='HeaderLogo-mobile'>
                    <div className="header-top">
                        <img src={logoBranco} width={100} alt="Esplane" className="logo" />
                        <div className="client-info">
                            <p className="client-name-mobile">{dadosNF.fec_infos?.[0]?.nomeparc ? dadosNF.fec_infos?.[0]?.nomeparc : ''}</p>
                            <p className="client-name-mobile">{dadosNF.fec_infos?.[0]?.razaosocial ? dadosNF.fec_infos?.[0]?.razaosocial : ''} ({dadosNF.fec_infos?.[0]?.codparc}) </p>
                            <p className="client-cpf">CPF/CNPJ: {dadosNF.fec_infos?.[0]?.cpf ? dadosNF.fec_infos?.[0]?.cpf : ''}</p>
                        </div>
                    </div>

                    <div className="header-bottom">
                        <div className="seller-info">
                            <span>Vendedor: <strong>{dadosNF.fec_infos?.[0]?.vendedor ? dadosNF.fec_infos?.[0]?.vendedor : '-'}</strong></span>
                            <span className="phone"> <Icon name="whatsapp" color="green" />{dadosNF.fec_infos?.[0]?.telefone ? dadosNF.fec_infos?.[0]?.telefone : '-'}</span>
                        </div>
                        <div className="order-info">
                            <span>Pedido: <strong>{dadosNF.fec_infos?.[0]?.pedido ? dadosNF.fec_infos?.[0]?.pedido : ''}</strong></span>
                            <span>Data: <strong>{dadosNF.fec_infos?.[0]?.data_pedido ? moment(dadosNF.fec_infos?.[0]?.data_pedido).format('DD/MM/YYYY') : ''}</strong></span>
                        </div>
                    </div>
                </div>

            </MobileView >
        </>
    );
}

const mapStateToProps = (state) => ({
    dadosNF: state.EntregaCerta.dadosNF,
    isLoadingBody: state.EntregaCerta.isLoadingBody,
})

export default connect(mapStateToProps, {

}
)(Header);
